import clsx from 'clsx';
import React, { PropsWithChildren } from 'react';
import { createPortal } from 'react-dom';

type ModalProps = {
  onClose: () => void;
  footer: React.ReactNode;
  fullHeight?: boolean;
  fullWidth?: boolean;
  className?: string;
};

export function Modal({ onClose, footer, children, fullHeight, fullWidth, className }: PropsWithChildren<ModalProps>) {
  return createPortal(
    <div className="relative z-10" aria-labelledby="dialog-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500/75 z-100 w-screen flex justify-center items-center">
        <div
          className={`flex min-h-full items-center justify-center text-center w-full ${fullHeight ? 'sm:p-4' : 'p-4'}`}
          onClick={onClose}
        >
          <div
            className={clsx(
              `flex flex-1 flex-col relative transform overflow-hidden rounded-lg bg-dark px-4 pt-5 pb-4 text-left shadow-xl  max-w-full sm:max-w-md sm:p-6 mt-[var(--discord-safe-area-inset-top,0px)] sm:mt-0 sm:mb-0`,
              {
                'h-[calc(100lvh-var(--discord-safe-area-inset-top,0px))] pb-[var(--discord-safe-area-inset-bottom,0px)] sm:h-[calc(100lvh-2rem)] rounded-none sm:rounded-lg':
                  fullHeight,
                'sm:my-8 max-h-[calc(100lvh-4rem)]': !fullHeight,
                'w-full': fullWidth,
              },
              className
            )}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={clsx('overflow-y-auto w-full', { 'h-full flex-1': fullHeight })}>{children}</div>
            <div className="mt-5 sm:mt-6 w-full shrink-0">{footer}</div>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
}
